import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';



@NgModule({
  declarations: [
    LoaderComponent,
    ProfilePictureComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LoaderComponent,   // IMPORTANT
    ProfilePictureComponent
  ]
})
export class SharedModule { }
